import { IToastConfig } from 'src/common/primitives/Toast';

export function generateDeleteSuccessToast(id: number): IToastConfig {
  return {
    id,
    title: `Success`,
    description: 'The tag has been deleted.',
    type: 'success',
  };
}
